export default __webpack_public_path__ + "static/media/testSongOgg.585f65e8.ogg";